import { buildApiUrl } from '../lib/api';
import { buildPlanLookupQuery } from './userIdentity';

export function normalizePlan(value) {
  return String(value || '').toUpperCase() === 'PRO' ? 'PRO' : 'FREE';
}

async function requestPlan(query) {
  const response = await fetch(`${buildApiUrl('/get-plan')}?${query}`);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const data = await response.json();
  return {
    plan: normalizePlan(data?.plan),
    entitlementPlan: normalizePlan(data?.entitlementPlan ?? data?.plan),
    preferredPlan: data?.preferredPlan || null,
    authoritative: data?.entitlementPlan !== undefined,
  };
}

export async function fetchUserPlanDetails(identity) {
  const primaryQuery = buildPlanLookupQuery(identity);
  let resolved = { plan: 'FREE', entitlementPlan: 'FREE', preferredPlan: null };
  if (!primaryQuery) return resolved;
  const queries = [primaryQuery];
  if (identity?.email && identity?.userId) queries.push(buildPlanLookupQuery({ email: identity.email }));
  let lastError;
  let successful = false;
  for (const query of queries) {
    try {
      const next = await requestPlan(query);
      successful = true;
      // An explicit FREE preference must never be overwritten by an email fallback.
      if (next.authoritative || next.preferredPlan || next.plan === 'PRO') return next;
      resolved = next;
    } catch (error) { lastError = error; }
  }
  if (!successful && lastError) throw lastError;
  return resolved;
}

export async function fetchResolvedUserPlan(identity) {
  return (await fetchUserPlanDetails(identity)).plan;
}
